import React from 'react';
import { Card } from "react-bootstrap";
import face_Anna_Torok from "../../assets/img/face_Anna_Torok.jpg";
import face_Zsofia_Cserdi from "../../assets/img/face_Zsofia_Cserdi.png";
import ShowMoreText from "react-show-more-text";
import projZsofiaCserdi_invisible from "../../assets/img/projZsofiaCserdi_invisible.png";

const Zs_Cserdi_and_A_Torok_invisible = () => {
    return (
        <Card className="CARD2" bg="dark">
        {/* <Card.Title><h2>Psychological characteristics behind (academic) performance</h2></Card.Title> */}
        <Card.Img variant="top" src={projZsofiaCserdi_invisible} />
        <br />
        <Card.Body>
          <Card.Text class="d-flex justify-content-between card-text">
            {" "}

            <div>
            <img
              className="img2"
              src={face_Zsofia_Cserdi}
              
            />{" "}
            <p className="text7">Zsófia Cserdi</p>
            <br />
            <p className="text8">
              Assistant Professor{" "}
            </p>
            </div>
            <div>
            <img
              className="img2"
              src={face_Anna_Torok}
              
            />{" "}
            <p className="text7">Anna Török</p>
            <br />
            <p className="text8">
              Assistant Professor{" "}
            </p>
            </div>
            
          </Card.Text>
          <ShowMoreText lines={1}>
            <div>
            <p className="text8">Institute of Marketing and Communication Sciences, Corvinus University of Budapest</p>
            </div>
            
            <div>
            The Hidden Disabilities Sunflower initiative constitutes a structured approach to enhancing the 
            visibility of non-apparent disabilities, enabling affected individuals to discreetly communicate 
            their support needs while promoting societal awareness and advancing the development of more 
            inclusive environments. The aim of this study is to explore the awareness of the symbol (sunflower) 
            and the program (Hidden Disabilities Sunflower) on social media sites (Facebook, Instagram, TikTok, 
            Reddit) in dedicated countries. Contents and engagement, including comments and consumer reactions, 
            would be analyzed, with sentiment analysis applied to assess the underlying attitudes and emotional tone.
            

            </div>
          </ShowMoreText>
        </Card.Body>
      </Card>
    );
};

export default Zs_Cserdi_and_A_Torok_invisible;